import './month_converter.js.coffee'
import './hour_converter.js.coffee'
import './minute_converter.js.coffee'
import './day_converter.js.coffee'
import './week_converter.js.coffee'

Namespace 'CustomerVisualMode.Filters.LastInterval.Converters'

CONVERTERS = CustomerVisualMode.Filters.LastInterval.Converters

class CustomerVisualMode.Filters.LastInterval.Converters.Converter
  constructor: ->
    @convertersByAscendingSpecificity = [
      {type: 'month', converter: new CONVERTERS.MonthConverter()},
      {type: 'week', converter: new CONVERTERS.WeekConverter()},
      {type: 'day', converter: new CONVERTERS.DayConverter()},
      {type: 'hour', converter: new CONVERTERS.HourConverter()},
      {type: 'minute', converter: new CONVERTERS.MinuteConverter()},
    ]

  getLabelFromSeconds: (seconds) ->
    selectedConverter = _.values(@convertersByAscendingSpecificity).find((value) -> value.converter.canConvert(seconds))
    throw new Error("No converter can handle the seconds: #{seconds}") unless selectedConverter

    selectedConverter.converter.getLabelFromSeconds(seconds)

  toSeconds: (type, value) ->
    converter = @_getConverter(type)
    converter.toSeconds(value)

  _getConverter: (type) ->
    converter = _.values(@convertersByAscendingSpecificity).find((converter) -> converter.type == type).converter
    throw new Error("unknown converter type #{type}") unless converter
    converter
